import { Injectable, Inject } from '@angular/core';
import { Observable, of } from 'rxjs';

import { BrandService } from 'shared/brand/brand.service';
import { ProfileInfoService } from 'shared/profile/profile-info.service';
import { TeamService } from 'shared/team/team.service';
import { PreferencesService } from 'shared/preferences/preferences.service';
import { BillingService } from 'shared/billing/billing.service';
import { BrandInfoService } from 'shared/brand/brand-info.service';
import { TradeInfoService } from 'shared/trade-info/trade-info.service';

// segment data
import { profileSegmentData } from './segment-data/profile-segment-data';
import { teamSegmentData } from './segment-data/team-segment-data';
import { preferencesSegmentData } from './segment-data/preferences-segment-data';
import { billingSegmentData } from './segment-data/billing-segment-data';
import { brandInfoSegmentData } from './segment-data/brand-info-segment-data';
import { tradeInfoSegmentData } from './segment-data/trade-info-segment-data';

import {
  PREFERENCES_NAME, PROFILE_NAME, TEAM_NAME, BILLING_NAME, BRAND_NAME,
  TRADE_INFO_NAME,
} from './variables';

@Injectable()
export class AccountInformationService {

  constructor(
    @Inject(BrandService) private brandService: BrandService,
    @Inject(ProfileInfoService) private profileInfoService: ProfileInfoService,
    @Inject(TeamService) private teamService: TeamService,
    @Inject(PreferencesService) private preferencesService: PreferencesService,
    @Inject(BillingService) private billingService: BillingService,
    @Inject(BrandInfoService) private brandInfoService: BrandInfoService,
    @Inject(TradeInfoService) private tradeInfoService: TradeInfoService,
  ) {}

  getSegmentData(segment: string) {
    switch (segment) {
      case PROFILE_NAME:
        return profileSegmentData;
      case TEAM_NAME:
        return teamSegmentData;
      case PREFERENCES_NAME:
        return preferencesSegmentData;
      case BILLING_NAME:
        return billingSegmentData;
      case BRAND_NAME:
        return brandInfoSegmentData;
      case TRADE_INFO_NAME:
        return tradeInfoSegmentData;
      default:
        return {};
    }
  }

  getData(segment: string): Observable<any> {
    const brandId = this.brandService.getBrand();
    switch (segment) {
      case PROFILE_NAME:
        return this.profileInfoService.fetch();
      case TEAM_NAME:
        return this.teamService.fetch(this.brandService.getBrand());
      case PREFERENCES_NAME:
        return this.preferencesService.getPreferences();
      case BRAND_NAME:
        return this.brandInfoService.fetch(brandId);
      case TRADE_INFO_NAME:
        return this.tradeInfoService.fetch(brandId);
      default:
        return of({});
    }
  }
}
